import * as React from 'react';
import { connect } from 'react-redux';

import API from '../../api';
import { IStore } from '../../store';
import { emptyUserMarkets, MarketContext, IUserMarkets } from './MarketContext';

interface IWrapperProps {
  userLoggedIn: boolean;
  children: (loading: boolean) => React.ReactNode;
}
interface IWrapperState {
  markets: IUserMarkets;
  loading: boolean;
}

class Wrapper extends React.Component<IWrapperProps, IWrapperState> {
  state = { markets: emptyUserMarkets, loading: false };

  fetchMarkets = async () => {
    this.setState({ loading: true });
    const { getData } = API.USER.profile();
    const userMarkets = await getData();
    this.setState({ markets: userMarkets, loading: false });
  };

  componentDidMount() {
    if (this.props.userLoggedIn) {
      this.fetchMarkets();
    }
  }

  componentDidUpdate(prevProps: IWrapperProps) {
    if (this.props.userLoggedIn && !prevProps.userLoggedIn) {
      this.fetchMarkets();
    }
  }

  render() {
    const { loading, markets } = this.state;
    const { children } = this.props;
    return (
      <MarketContext.Provider value={markets}>
        {children(loading)}
      </MarketContext.Provider>
    );
  }
}

const mapStateToProps = ({ user }: IStore) => ({
  userLoggedIn: Boolean(user.username),
});
export const MarketContextWrapper = connect(mapStateToProps)(Wrapper);



// WEBPACK FOOTER //
// ./src/services/contexts/markets/MarketProvider.tsx